// ===========================================================================
// HighCostPage — entry point del módulo. Dos pestañas: Patients (lista,
// por defecto) y Analysis (panorama agregado). "El costo dice quién; lo
// clínico-social dice por qué y qué hacer."
// ===========================================================================
import React, { useState } from "react";
import { Container, Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import InsightsIcon from "@mui/icons-material/Insights";
import PatientsTab from "../components/Patients/PatientsTab";
import AnalysisTab from "../components/Analysis/AnalysisTab";

export default function HighCostPage() {
  const [tab, setTab] = useState(0);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" fontWeight={900}>
          High Cost
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Control room for the patients who concentrate spend — financial, clinical and social lenses.
        </Typography>
      </Box>

      <Paper variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 56 },
          }}
        >
          <Tab icon={<GroupsIcon />} iconPosition="start" label="Patients" />
          <Tab icon={<InsightsIcon />} iconPosition="start" label="Analysis" />
        </Tabs>
      </Paper>

      {tab === 0 && <PatientsTab />}
      {tab === 1 && <AnalysisTab />}
    </Container>
  );
}
